import { iconDismiss } from 'globals/assets';
import { transitionDuration, transitionFunction } from 'globals/styles';

const styles = {
  container: {
    display: 'flex',
    position: 'relative',
  },
  message: {
    flex: '1',
    backgroundColor: '#fff',
    marginBottom: '10px',
    filter: 'drop-shadow(rgba(0, 0, 0, 0.1) 1px 1px 3px)',
    fontSize: '14px',
    fontWeight: '400',
    padding: '9px 10px',
    borderRadius: '9px 9px 9px 0px',
    lineHeight: '16px',
    wordWrap: 'break-word',
    cursor: 'pointer',
    WebkitTransition: 'all .2s ease-in-out',
    transition: `all ${transitionDuration} ${transitionFunction}`,
    ':hover': {
      WebkitTransform: 'translateY(-5px) scale(1.05)',
      transform: 'translateY(-5px) scale(1.05)',
      WebkitFilter: 'drop-shadow(1px 1px 6px rgba(0,0,0,.33))',
      filter: 'drop-shadow(1px 1px 6px rgba(0,0,0,.33))',
    },
  },
  body: {
    wordWrap: 'break-word',
  },
  close: {
    backgroundImage: `url("${iconDismiss}")`,
    backgroundColor: '#3d3f41',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '8px 8px',
    borderRadius: 12,
    height: 24,
    width: 24,
    backgroundPosition: '50%',
    position: 'absolute',
    right: '-10px',
    top: '-12px',
  },
  avatar: {
    height: '30px',
    width: '30px',
    borderRadius: '15px',
    marginTop: '2px',
    marginRight: '10px',
    boxShadow: '0 0 22px 0 rgba(105,105,105,0.16)',
  },
};

export default styles;
